<template>
  <div class="building">
    <router-link :to="linkURL">
      <img :src="lightImgSrc" class="building-light grow" />
      <img
        :src="darkImgSrc"
        class="building-dark"
        :style="{ top: darkImgOffset + 'vw' }"
      />
    </router-link>
  </div>
</template>

<script>
import "hover.css";
export default {
  name: "Building",
  props: {
    linkURL: {
      type: String,
      default: "",
    },
    lightImgSrc: {
      type: String,
      default: "",
    },
    darkImgSrc: {
      type: String,
      default: "",
    },
    darkImgOffset: {
      type: Number,
      default: 0,
    },
  },
};
</script>
<style scoped lang="scss">
.building {
  position: fixed;
  :hover {
    .building-dark {
      transition: 0.3s;
      opacity: 0.8;
    }
  }
  .building-light {
    width: 100%;
  }
  .building-dark {
    z-index: -1;
    position: relative;
    transition: 0.3s;
    opacity: 0;
    width: 100%;
  }
}
@mixin hideTapHighlightColor() {
  //Prevent highlight colour when element is tapped
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

@mixin hardwareAccel() {
  //Improve performance on mobile/tablet devices
  transform: translateZ(0);
}

@mixin improveAntiAlias() {
  //Improve aliasing on mobile/tablet devices
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
}
.grow {
  transition-duration: 0.2s;
  transition-property: transform;

  @include hideTapHighlightColor();
  @include hardwareAccel();
  @include improveAntiAlias();

  &:hover {
    transform: scale(1.03);
  }
}
</style>
